import { render, staticRenderFns } from "./storageGoods.vue?vue&type=template&id=62a316c8&"
import script from "./storageGoods.vue?vue&type=script&lang=js&"
export * from "./storageGoods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports